import { useEffect, useState } from "react";

const useToggleStylesheet = (isRTL, isDark, configDispatch) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);

    Array.from(document.getElementsByClassName("theme-stylesheet")).forEach(
      (link) => link.remove()
    );
    Array.from(document.getElementsByClassName("user-stylesheet")).forEach(
      (link) => link.remove()
    );
    Array.from(
      document.getElementsByClassName("webshop-layout-stylesheet")
    ).forEach((link) => link.remove());

    const themeLink = document.createElement("link");
    themeLink.href = `${process.env.PUBLIC_URL}/css/theme${
      isRTL ? "-rtl" : ""
    }.min.css`;
    themeLink.type = "text/css";
    themeLink.rel = "stylesheet";
    themeLink.className = "theme-stylesheet";

    const userLink = document.createElement("link");
    userLink.href = `${process.env.PUBLIC_URL}/css/user${
      isRTL ? "-rtl" : ""
    }.min.css`;
    userLink.type = "text/css";
    userLink.rel = "stylesheet";
    userLink.className = "user-stylesheet";

    // Must load after theme/user so mockup nav colors win
    const webshopLink = document.createElement("link");
    webshopLink.href = `${process.env.PUBLIC_URL}/css/webshop-layout.css`;
    webshopLink.type = "text/css";
    webshopLink.rel = "stylesheet";
    webshopLink.className = "webshop-layout-stylesheet";

    let loadedCount = 0;
    const onLoad = () => {
      loadedCount++;
      if (loadedCount === 3) {
        setIsLoaded(true);
      }
    };

    themeLink.onload = onLoad;
    userLink.onload = onLoad;
    webshopLink.onload = onLoad;
    themeLink.onerror = onLoad;
    userLink.onerror = onLoad;
    webshopLink.onerror = onLoad;

    const head = document.getElementsByTagName("head")[0];
    head.appendChild(themeLink);
    head.appendChild(userLink);
    head.appendChild(webshopLink);

    document
      .getElementsByTagName("html")[0]
      .setAttribute("dir", isRTL ? "rtl" : "ltr");
  }, [isRTL]);

  useEffect(() => {
    document.documentElement.classList[isDark ? "add" : "remove"]("dark");
    configDispatch({
      type: "REFRESH",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDark]);

  return { isLoaded };
};

export default useToggleStylesheet;
